import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ContactFormContextType {
  isOpen: boolean;
  title: string;
  scrollPosition: number;
  openForm: (title?: string) => void;
  closeForm: () => void;
}

const ContactFormContext = createContext<ContactFormContextType | undefined>(undefined);

interface ContactFormProviderProps {
  children: ReactNode;
}

export const ContactFormProvider: React.FC<ContactFormProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("Contact Paokhum");
  const [scrollPosition, setScrollPosition] = useState(0);

  const openForm = (newTitle?: string) => {
    setTitle(newTitle || "Contact Paokhum");
    console.log('=== CONTACT FORM OPENFORM CALLED ===');
    console.log('Current scroll in openForm:', window.scrollY);
    console.log('Current URL in openForm:', window.location.href);
    
    // Store current scroll position before opening popup
    const scrollY = window.scrollY;
    
    console.log('Setting scroll position and isOpen...');
    setScrollPosition(scrollY);
    setIsOpen(true);
    
    // Stop any smooth scrolling behavior immediately
    document.documentElement.style.scrollBehavior = 'auto';
    
    console.log('=== CONTACT FORM OPENFORM END ===');
  };

  const closeForm = () => {
    setIsOpen(false);
    // Keep scroll position until popup is fully closed
    
    // Restore normal scroll behavior
    document.documentElement.style.scrollBehavior = 'auto';
  };

  return (
    <ContactFormContext.Provider value={{ isOpen, title, scrollPosition, openForm, closeForm }}>
      {children}
    </ContactFormContext.Provider>
  );
};

export const useContactForm = () => {
  const context = useContext(ContactFormContext);
  if (context === undefined) {
    throw new Error('useContactForm must be used within a ContactFormProvider');
  }
  return context;
};
